const Backbone = require('lib/backbone')
const Button = require('./button_model')

const log = require('log').create('button'); // eslint-disable-line


const ButtonList = Backbone.Collection.extend({

     
    constructor: function constructor(models, options) {
        if (models instanceof ButtonList) return ButtonList

        Backbone.Collection.apply(this, arguments)
    },

    model: Button,

})

module.exports = ButtonList
